/* eslint-disable max-len */
/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import utils, { TJoin, TModule, TNonEmptyArray, TRole, TRoleClaim, TTenant, TUser, TUserClaim, TUserModuleAccess, TUserRole } from "../../helpers/utils.graphql";
import { CommandResult_User, ListCommandResult_User } from "../../helpers/types.graphql";
import { CommandResult, ListCommandResult } from "../fragment.graphql";

export type TGlobal = TUser
  | TJoin<"tenant", TTenant>
  | TJoin<"userRoles", TUserRole>
  | TJoin<"userRoles.role", TRole>
  | TJoin<"userRoles.role.module", TModule>
  | TJoin<"userRoles.role.roleClaims", TRoleClaim>
  | TJoin<"userClaims", TUserClaim>
  | TJoin<"userModuleAccesses", TUserModuleAccess>
  | TJoin<"userModuleAccesses.module", TModule>;

type TUserByIdFunctions = { getByID: CommandResult_User }
export type TUserByIdQueries = { user: TUserByIdFunctions };
export const userById = (fields: TNonEmptyArray<TGlobal>) => gql`
  query userById($id: Guid!) {
    user {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_User")}
`;

type TUserAllWithPaginationFunctions = { getAllWithPagination: ListCommandResult_User }
export type TUserAllWithPaginationQueries = { user: TUserAllWithPaginationFunctions };
export const userAllWithPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query userAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    user {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_User")}
`;

type TUserAllWithSortedPaginationFunctions = { getAllWithSortedPagination: ListCommandResult_User }
export type TUserAllWithSortedPaginationQueries = { user: TUserAllWithSortedPaginationFunctions };
export const userAllWithSortedPagination = (fields: TNonEmptyArray<TGlobal>) => gql`
  query userAllWithSortedPagination(
    $page: Int, $perPage: Int, $where: [WhereClausesInputType], $sort: [SortClausesInputType]
  ) {
    user {
      getAllWithSortedPagination(page: $page, perPage: $perPage, where: $where, sort: $sort) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_User")}
`;